<script>
  import { LoaderCircle } from 'lucide-svelte'  
  import { cn } from '@lib/utils'

  let { message, spinnerSize = 30, class: className } = $props()
</script>

<div class={cn('flex items-center justify-center h-80 text-gray-500 text-sm', className)}>
  <div class="flex gap-2">
    {#if message}
      <span>{message}</span>
    {:else}
      <LoaderCircle size={spinnerSize} class="animate-spin" />
    {/if}
  </div>
</div>